var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366.3 1894",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #606060;\n      }\n\n      .cls-3 {\n        fill: #3b3b3b;\n      }\n\n      .cls-4 {\n        fill: #292929;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M950.4,1282.21s-12.75,6.62-17.09,6.01c-3.92-.55-15.95-10.62-15.95-10.62,0,0,8.01,13.83,7.49,17.55-.63,4.54-12.1,15.48-12.1,15.48,0,0,13.48-6.36,17.22-5.84,4.52.63,15.82,10.45,15.82,10.45,0,0-6.47-12.74-5.84-17.27.52-3.73,10.44-15.77,10.44-15.77Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g2622"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2615",
    className: "cls-3",
    d: "M357.72,41.72c-81.54,26.23-163.73,67.75-210.5,160.14-69.62,157.08-58.87,330.53-30.38,498.69,14.58,86.05-16,210.45-52.89,289.33C22.94,1077.55,0,1175.34,0,1278.52c.63,214.52,101.98,416.02,273.19,544.44,6.92,5.19,14.89,9.08,23.19,11.51,312.92,91.52,555.77,66.23,774.04-.01,8.05-2.44,15.66-6.23,22.4-11.27,171.38-128.41,272.85-330.01,273.48-544.66,0-101.95-22.39-198.62-62.48-285.47-36.49-79.07-58.79-201.54-37.88-286.25,32.46-131.56,62.64-316,21.15-445.17-26.35-82.02-98.28-168.8-205.93-207.26C911.49-6.26,561.91-23.97,357.72,41.72h0ZM685.26,251.18c137.63,1.91,278.9,25.35,321.81,40.68,82.04,31.59,77.16,148.29,56.57,253.07-15.78,80.34-93.09,108.45-170.87,83.33-66.04-21.33-136.46-32.87-209.61-32.87-67.3,0-132.3,9.75-193.71,27.91-78.39,23.17-147.68-8.53-151.35-90.31-5.15-114.9,6.59-195.64,14.83-211.86,10.72-20.7,117.84-72.92,332.37-69.95h-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2617",
    className: "cls-2",
    d: "M813.25,712.63c-147.91-37.61-467.16-5.77-515.28,209.95-48.12,215.72,474.89,148.66,623.19,83.73,148.3-64.93,52.23-237.62-107.91-293.68h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2618",
    className: "cls-2",
    d: "M609.58,48.7c-147.91,8.51-325.2,41.51-369.38,112.12-44.17,70.61,125.03,25.9,216.93,3.19,91.9-22.71,375.89-19.87,393.44-56.24,17.89-37.06-106.3-68.65-240.99-59.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2619",
    className: "cls-2",
    d: "M1137.11,579.35s-66.1,79.28-45.74,131.71c20.36,52.43,106.26-51.68,99.01-122.93-7.25-71.25-24.82-46.66-53.27-8.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2620",
    className: "cls-2",
    d: "M258.01,554.26c-44.07,17.56-51.6,157.8,10.6,151.53,62.19-6.27,44.07-156.55-10.6-151.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2621",
    className: "cls-4",
    d: "M1365.88,1263.08c-138.38,172.91-416.51,361.38-799.14,327.77-280.56-24.65-458.42-157.07-565.69-280.6,10.01,202.55,109.44,390.67,272.18,512.73,6.9,5.18,14.85,9.05,23.13,11.48,312.94,91.53,555.79,66.24,774.08,0,8.05-2.44,15.66-6.23,22.4-11.27,171.38-128.41,272.85-330.01,273.48-544.66,0-5.18-.3-10.29-.42-15.44h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/Weight.17a8cce8816826cbd812037038ad40e0.svg";
export { ForwardRef as ReactComponent };